import React from "react";
import withMotion from "../../../../Utils/withMotion";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Blog.scss";
import { Link } from "react-router-dom";

//Utils
import { mapBlogs } from "../../Pagination/utils";

//Images
import banner from "../../images/drivewayComparing/material-comparison-banner.jpg";
import asphalt from "../../images/drivewayComparing/asphalt-driveway.jpeg";
import brick from "../../images/drivewayComparing/brick-driveway.jpg";
import concrete from "../../images/drivewayComparing/concrete-driveway.jpeg";
import paver from "../../images/drivewayComparing/paver-driveway.jpg";
import samples from "../../images/drivewayComparing/paver-samples.jpg";
import ugly from "../../images/drivewayComparing/ugly-driveway.jpg";
import winner from "../../images/drivewayComparing/winner.jpg";

// SEO
import SEO from "../../../../SEO/index.js";
import StructuredData from "../../../../SEO/structuredData";
import { ViewPavers } from "../../../../CTA/CTA";

export const DrivewayComparingData = {
  title: "Driveway Paving: Comparing Asphalt vs. Brick vs. Concrete",
  image: banner,
  destination: "/blog/driveway-paving-comparing-asphalt-vs-brick-vs-concrete",
  date: "July 26, 2016",
  categories: ["blog", "driveways", "paving-stones"],
};

const DrivewayComparing = () => {
  const blog = [DrivewayComparingData];

  return (
    <>
      <SEO
        title="Asphalt vs. Brick vs. Concrete Driveway Paving - Which is Best?"
        description="Here in Southern California area there are several options for driveway paving materials. Learn which material is best for your property!"
        profileURL={
          "https://www.pacificpavingstone.com/blog/driveway-paving-comparing-asphalt-vs-brick-vs-concrete"
        }
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "BlogPosting",
          author: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
          URL: "https://www.pacificpavingstone.com/blog/driveway-paving-comparing-asphalt-vs-brick-vs-concrete",
          headline:
            "Asphalt vs. Brick vs. Concrete Driveway Paving - Which is Best?",
          description:
            "Here in Southern California area there are several options for driveway paving materials. Learn which material is best for your property!",
          image: {
            "@type": "ImageObject",
            url: "https://www.pacificpavingstone.com/static/media/material-comparison-banner.16520011.jpg",
          },
          datePublished: "2016-07-26",
          publisher: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
        }}
      />
      <div className="container-fluid page-blog">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-6">
            {mapBlogs(1, blog, true)}
            <div className="row">
              <div className="col-12 col-md-5">
                <img src={ugly} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p>
                  It’s time. You just can’t take that ugly, cracked driveway any
                  longer. You’ve looked enviously at driveways on your commute
                  and there seem to be so many options that it makes you dizzy.
                  <br />
                  <br />
                  Here in Los Angeles and the Southern California area there are
                  several options for driveway paving materials. Understanding
                  which material is best for your property can give your home
                  that touch of class you’re looking for while reducing
                  maintenance and aggravation.
                </p>
              </div>
            </div>
            <h4>Southern California Options for Driveway Paving Materials</h4>
            <h4>Asphalt Driveway Paving</h4>
            <p>
              This is clearly the cheapest choice for driveways for a number of
              reasons. Approximately 5-10% of Southern California homeowners
              choose asphalt when installing a new driveway.
            </p>
            <div className="row">
              <div className="col-12 col-md-5">
                <img src={asphalt} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p>
                  The cost is typically around $4/sq. ft. Even with the best
                  installation, asphalt will only last about 10 years, chipping,
                  fading, and cracking along the way.
                  <br />
                  <br />
                  Asphalt driveways will need to be sealed every few years to
                  keep them looking nice and will definitely be the scorching
                  hot under the summer sun.
                  <br />
                  <br />
                  You may save some money on the front end, but installing an
                  ugly asphalt driveway isn’t worth the little bit of money
                  you’ll save.
                </p>
              </div>
            </div>
            <p>
              <span className="text-blue">Asphalt Driveway Paving Pros:</span>{" "}
              Cheap
            </p>
            <p>
              <span className="text-blue">Asphalt Driveway Paving Cons:</span>{" "}
              Ugly, cracks, high maintenance, poor longevity
            </p>

            <h4>Brick Driveway Paving</h4>
            <p>
              Bricks are not a good choice for driveway paving materials. Only
              about 5-10% of Southern California homes use this material for new
              driveways. Brick driveways are laid on top of a 4-inch poured
              concrete foundation and fastened with mortar.
            </p>
            <div className="row">
              <div className="col-12 col-md-5">
                <img src={brick} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p>
                  Mortar and the concrete foundation are both prone to cracking,
                  especially when the weight of a vehicle is on them. Bricks are
                  not the same as paving stones. Pavers are made from concrete
                  and can take more weight than traditional clay bricks.
                  <br />
                  <br />
                  Bricks are just a bad, all-around choice for driveway paving
                  that end up with a premium cost around $30/sq. ft.
                </p>
              </div>
            </div>
            <p>
              <span className="text-blue">Brick Driveway Paving Pros:</span>{" "}
              Better appearance than concrete or asphalt
            </p>
            <p>
              <span className="text-blue">Brick Driveway Paving Cons:</span>{" "}
              Easily broken, prone to cracks, high-maintenance, poor longevity,
              very expensive
            </p>

            <h4>Concrete Driveway Paving</h4>
            <p>
              Approximately 50% of newly installed driveways in the Los Angeles
              and surrounding areas are made of poured concrete. This driveway
              paving method ranges from a standard, poured application or
              stamped concrete.
              <br />
              <br />
              Stamped concrete driveways are only cosmetically different than
              traditional poured concrete driveways to try to imitate paving
              stone driveways. In some instances, this imitation could even be
              more costly than pavers.
            </p>
            <div className="row">
              <div className="col-12 col-md-5">
                <img src={concrete} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p>
                  The cost for most concrete driveway paving applications ranges
                  around $7.50/sq. ft. Concrete driveways will only last for
                  10-20 years and are extremely likely to develop cracks, even
                  within months of installation.
                  <br />
                  <br />
                  In fact, the installation of concrete driveways actually plans
                  for this cracking by placing expansion joints to try to direct
                  the crack when it happens along a defined line. Concrete can
                  also chip which cannot be easily repaired without noticing
                  unsightly patches.
                </p>
              </div>
            </div>
            <p>
              <span className="text-blue">Concrete Driveway Paving Pros:</span>{" "}
              Moderate price, moderate maintenance
            </p>
            <p>
              <span className="text-blue">Concrete Driveway Paving Cons:</span>{" "}
              Very prone to cracking, difficult to repair, ugly expansion joints
            </p>

            <h4>Pavingstone Driveway Paving</h4>
            <div className="row">
              <div className="col-12 col-md-5">
                <img src={paver} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p>
                  This material is becoming increasingly more popular as
                  driveway paving material, particularly in Southern California.
                  Approximately 40% of new driveway installations use
                  interlocking paving stones (pavers).
                  <br />
                  <br />
                  The cost of pavingstone driveways is just slightly higher than
                  most concrete driveways, but pavers offer a number of
                  fantastic features other driveway paving materials do not. For
                  a starting cost of approximately $8.50/sq. ft., paving stone
                  driveways offer the strongest material you can park or drive
                  on.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-5">
                <img src={samples} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p>
                  Colors, sizes, textures, and patterns can create hundreds of
                  unique styles to complement your Los Angeles property. These
                  stones have a classy look and also last for decades. Many
                  paving stone driveways we’ve installed almost 20 years ago,
                  still look amazing!
                  <br />
                  <br />
                  One distinct advantage of paving stone driveways is their
                  ability to be repaired. It’s rare to have an area settle with
                  an expert installation due to this flexible, interlocking
                  alternative. However, if repair is warranted or an area needs
                  to be temporarily removed to run an underground conduit or a
                  utility line, this type of driveway can easily be repaired
                  with virtually no evidence of disturbance.
                </p>
              </div>
            </div>
            <p>
              <span className="text-blue">
                Pavingstone Driveway Paving Pros:
              </span>{" "}
              Most durable, easily repaired, minimal maintenance, longest
              lifespan, beautiful aesthetic options
            </p>
            <p>
              <span className="text-blue">
                Pavingstone Driveway Paving Cons:
              </span>{" "}
              Slightly higher cost for installation
            </p>

            <h4>The Clear Winner for Driveway Paving Materials</h4>
            <p>
              Without a doubt,{" "}
              <span className="text-blue">
                choosing paving stones for your new driveway is the winning
                option
              </span>{" "}
              for your Southern California property.
              <br />
              <br />
              These classy materials will not only save you aggravation, but can
              increase the value of your home. Many Los Angeles homes have small
              front yards which can be beautifully designed to unite a gorgeous
              new driveway with a complementing paverstone walkway and
              well-thought out plantings.
            </p>
            <h4>Who Should Install Your New Pavingstone Driveway?</h4>
            <div className="row">
              <div className="col-12 col-md-5">
                <img src={winner} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p>
                  Pacific Pavingstone has installed thousands beautiful Southern
                  California driveways over the past couple decades. Our
                  designers will work with you to find the perfect driveway that
                  you can’t wait to come home to each day.
                  <br />
                  <br />
                  Our in-house team of ICPI certified installers will work
                  diligently to make sure your new pavingstone driveway lasts
                  for decades.
                  <br />
                  <br />
                  We’d love to talk about your driveway paving needs! Give us a
                  call at (818) 275-8613 or{" "}
                  <Link to="/contact-us">contact us online for a FREE</Link>, No
                  Obligation Estimate and be on your way to a new driveway!
                </p>
              </div>
            </div>
            <ViewPavers/>
          </div>
          <Sidebar />
        </div>
      </div>
    </>
  );
};

export default withMotion(DrivewayComparing);
